import React from "react";

import ActionWarning from "core/ActionWarning";

// icons:
import TrashIcon from "core/ReusableIcons/Trash";

import { useWithdrawPhotoUpload } from "../../PhotoUploadCore/hooks";
import { useEditPhotoUpload } from "../../PhotoUpload/Edit/EditPhotoUploadContext";
import { useSelect } from "../../PhotoUpload/hooks/useSelect";

const DeletePhotoSection = () => {
    const { withdrawPhotos } = useWithdrawPhotoUpload();
    const {
        closeEditModal,
        uploadIds = [],
        isBatchEditing
    } = useEditPhotoUpload();

    const { clearAllChecked } = useSelect();

    const handleDeleteSelected = () => {
        withdrawPhotos({
            variables: {
                photoUploadIds: uploadIds
            }
        }).then(res => {
            const success =
                res.data && res.data.withdrawPhotoUploads
                    ? res.data.withdrawPhotoUploads.ok
                    : false;
            if (success) {
                clearAllChecked();
                closeEditModal();
            }
        });
    };

    const numberOfPhotosInEdit = uploadIds.length;
    const singularButtonText = "Are you sure you want to delete this photo?";
    const multipleButtonText = `Are you sure you want to delete ${numberOfPhotosInEdit} photos?`;

    return (
        <ActionWarning
            triggerText={
                <>
                    {isBatchEditing
                        ? `Delete ${numberOfPhotosInEdit} Photos`
                        : "Delete Photo"}
                </>
            }
            buttonProps={{
                width: "100%",
                styleType: "outline",
                size: "lg",
                justifyContent: "center",
                iconPosition: "center",
                processingIconPosition: "center"
            }}
            showCloseButton={false}
            width="100%"
            heading={isBatchEditing ? multipleButtonText : singularButtonText}
            submitText={`Yes, delete photo${isBatchEditing ? "s" : ""}`}
            onSubmit={handleDeleteSelected}
            onCancel={() => {}}
        />
    );
};

export default DeletePhotoSection;
